import React from 'react';
import { Header, Trigger } from '@radix-ui/react-accordion';
import { Icon, IconsEnum } from 'components/Icons';

import { ItemWithTranslation } from 'types/swagger';
import styles from './ScommesseAccordionTrigger.module.scss';
import { useTranslation } from 'hooks/useLingUI';
import { Tooltip, TooltipPosition } from 'components/tooltip';
import { useInfoTipo } from 'features/sport/hooks';
import { KeyManagerSport } from 'features/sport';
import { hasValue } from 'utility/functions';

export type ScommesseAccordionTriggerProps = ItemWithTranslation<{
  text: string;
  infoTipoScommessaKeyStringList?: Array<string>;
  avvenimentoKey?: string;
}>;

// eslint-disable-next-line react/display-name
export const ScommesseAccordionTrigger = React.forwardRef<HTMLButtonElement, ScommesseAccordionTriggerProps>(
  ({ text, textTrKey, avvenimentoKey, infoTipoScommessaKeyStringList }, forwardedRef) => {
    const { t } = useTranslation();

    const keyScommessa =
      infoTipoScommessaKeyStringList?.length === 1
        ? `${avvenimentoKey}-${infoTipoScommessaKeyStringList[0]}`
        : undefined;

    const keys = new KeyManagerSport(keyScommessa!);
    const infoTipoScommessa = useInfoTipo(keys?.tipoScommessaId);
    const { toolTip, toolTipTrKey } = infoTipoScommessa ?? {};

    const tooltipContent = infoTipoScommessa && hasValue(toolTip) && t(toolTipTrKey, toolTip);

    return (
      <Header>
        <Trigger className={styles.container} ref={forwardedRef}>
          <div className={styles.titleContainer}>
            <p className={styles.text}>{t(textTrKey, text)}</p>
            {tooltipContent && <Tooltip content={tooltipContent} position={TooltipPosition.BOTTOM} />}
          </div>
          <Icon iconId={IconsEnum.CHEVRON_DOWN} className={styles.icon} color="var(--color-neutral-01)" />
        </Trigger>
      </Header>
    );
  }
);